import React, { useEffect, useState } from 'react';
import axios from 'axios';
import useInterval from '@use-it/interval';
import { setVideoPlayerPlaying } from '../actions'
import { useDispatch, useSelector } from 'react-redux'

export default function BitmovinPlayer({ videoRoom, playerConfig, streamSource, entranceRepeatTime, ...props }) {

  const entranceUrl = props.entranceUrl
  const streamKey = props.streamKey
  const videoPlayerPlaying = useSelector(state => state.videoPlayerPlaying)
  let player = null;
  const dispatch = useDispatch()

  const audioLanguage = useSelector(state => state.videoPlayerAudioTrack)

  async function apiCall(body, params) {
      await fetch('https://dotrzjfbkbt0b.cloudfront.net/prod/streams', {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          body: body,
      })
          .then(response => response.json())
          // ############ LOG FOR BROWSER ###################
          // .then(data => console.log("###SUCCESS", params, body))
          .catch(function() {
              console.log(params.httpStatus + " API CALL ERROR " + player.analytics.sessionHandler.userId);
          });
  }

  function audioChangedApiCall(params) {
      const body = JSON.stringify({
          "Records": [{
              "Data": {
                  "metric_type": "AUDIO_CHANGED",
                  "user_id": player.analytics.sessionHandler.userId,
                  "client_platform": player.analytics.sample.platform,
                  "is_live": player.analytics.config.isLive,
                  "sourceAudio": params.sourceAudio.lang,
                  "targetAudio": params.targetAudio.lang,
              }
          }]
      });
      apiCall(body, params);
  }

  function videoQualityChangedApiCall(params) {
      const body = JSON.stringify({
          "Records": [{
              "Data": {
                  "metric_type": "VIDEOQUALITY_CHANGED",
                  "user_id": player.analytics.sessionHandler.userId,
                  "client_platform": player.analytics.sample.platform,
                  "is_live": player.analytics.config.isLive,
                  "from_rendition_name": params.sourceQuality.label,
                  "to_rendition_name": params.targetQuality.label,
                  "from_rendition_bitrate": params.sourceQuality.bitrate,
                  "to_rendition_bitrate": params.targetQuality.bitrate,
                  "step_direction": {
                      "from": params.sourceQualityId,
                      "to": params.targetQualityId
                  }
              }
          }]
      });
      apiCall(body, params);
  }

  function pausedApiCall(params) {
      const body = JSON.stringify({
          "Records": [{
              "Data": {
                  "metric_type": "STOP",
                  "user_id": player.analytics.sessionHandler.userId,
                  "client_platform": player.analytics.sample.platform,
                  "is_live": player.analytics.config.isLive,
                  "end_playback_position_sec": params.time,
              }
          }]
      });
      apiCall(body, params);
  }

  function playApiCall(params) {
      const body = JSON.stringify({
          "Records": [{
              "Data": {
                  "metric_type": "PLAY",
                  "user_id": player.analytics.sessionHandler.userId,
                  "client_platform": player.analytics.sample.platform,
                  "is_live": player.analytics.config.isLive,
                  "start_playback_position_sec": params.time,
                  "startup_latency_ms": player.analytics.playerStartupTime,
              }
          }]
      });
      apiCall(body, params);
  }


  let date = new Date();
  let firstEvent = false;
  function segmentPlaybackApiCall(params) {

      if( new Date(new Date() - date).getSeconds() > 50 || !firstEvent){
          const body = JSON.stringify({
              "Records": [{
                  "Data": {
                      "metric_type": "HEARTBEAT",
                      "user_id": player.analytics.sessionHandler.userId,
                      "client_platform": player.analytics.sample.platform,
                      "is_live": player.analytics.config.isLive,
                      "media_info": params.mediaInfo,
                      "playback_time": params.playbackTime
                  }
              }]
          });
          apiCall(body, params);
          date = new Date();
          firstEvent = true;
      }
  }







  const setTrack = (_player, _audioLanguage) => {
    console.log("setAudioTrack", _audioLanguage)
    if(_player) {
      const availableTracks = _player.getAvailableAudio()
      console.log("Available audio", availableTracks)
      const track = availableTracks.find(at => at.lang == _audioLanguage)
      if(track) {
        console.log("setting track", track)
        try {
          console.log(_player.setAudio(track.id))
          _player.play()
        } catch(ex) {
          console.error(ex)
        }
      } else {
        console.warn("No track found for ", _audioLanguage)
      }
    } else {
      console.warn("Player not initialized")
    }
  }
    

  useEffect(() => {
    setTrack(player, audioLanguage)
  }, [audioLanguage])

  const disposePlayer = () => {
    if(player) {
      player.destroy()
      alert("destroy")
    } else {
      debugger
    }

    dispatch(setVideoPlayerPlaying(false))
  }

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//cdn.bitmovin.com/player/web/8/bitmovinplayer.js';
    script.async = true;

    document.body.appendChild(script);

    script.onload = () => {
      var config = {
        key: "f957d43a-b82d-4ff0-9842-c4d5f51959b1",
        events: {
          audiochanged: audioChangedApiCall,
          videodownloadqualitychange: videoQualityChangedApiCall,
          paused: pausedApiCall,
          play: playApiCall,
          segmentplayback: segmentPlaybackApiCall
        },
        tweaks: {
          native_hls_parsing: true
        }
      }

      var playerSource = {}

      try {
        playerSource = JSON.parse(streamSource)
        console.log("Found player source", playerSource)
      } catch(ex) {
        console.error("invalid player source", streamSource, ex)
      }

      if(playerConfig) {
        if(playerConfig.playerConfig) {
          config = Object.assign({}, config, playerConfig.playerConfig)
        }
        if(playerConfig.sourceConfig) {
          playerSource = Object.assign({}, playerSource, playerConfig)
        }
        console.log("Updating config", config)
      }

      var container = document.getElementById('bitmovin_player_container');
      player = new bitmovin.player.Player(container, config);
      player.on(bitmovin.player.PlayerEvent.AudioChanged, (e) => {
        console.log('audio changed event', e)
        if(props.audioChanged)
          props.audioChanged.call(player, e)
      });
      //player.on(bitmovin.player.PlayerEvent.AudioTrack, (e) => console.log('audio track event', e));
      //player.on(bitmovin.player.PlayerEvent.AudioAdaption, (e) => console.log('audio adaption event', e));

      player.load(playerSource).then(() => {
          //setPlayer(player)
          console.log("Setting player", player, player, this)
          setTrack(player, props.defaultLanguage)

          if(props.audioChanged) {
            const audioData = player.getAudio()
            if(audioData.label && audioData.lang) {
              props.audioChanged.call(player, {
                targetAudio: {
                  lang: audioData.lang,
                  label: audioData.label
                }
              })
            }
          }
            
          console.log('Successfully created Bitmovin Player instance');
        },
        function(reason) {
          //setPlayer(null)
          console.error('Error while creating Bitmovin Player instance', reason);
        }
      )

    }
    
    return () => {
      console.error("DELETING", player)
      if(player) {
        try {
          player.destroy()
        } catch(ex) {
          console.error(ex)
        }
      }
    }
  }, [streamSource])

  useInterval(() => {
    if(player && player.isPlaying()) {
      if(!videoPlayerPlaying){
        dispatch(setVideoPlayerPlaying(true))
      }
      console.warn("playing")
    } else {
      if(videoPlayerPlaying){
        dispatch(setVideoPlayerPlaying(false))
      }
      console.warn("Not playing")
    }
  }, 3000);

  return (
      <div className="flave-video-container">
      <div
        onClick={props.onPlayerClick}
        className="fixed-player"
        id="bitmovin_player_container"
        data-kavedo={streamSource}
        style={{width: "100%", backgroundColor: "black", minHeight: "30px"}}
      />
        {props.renderCustomContent != "false" && 
          <>
            {props.children}
          </>
        }
      </div>
  )
}
